import type { PublicSettings } from '../services/settings';

export function resolveGoogleReviewUrl(settings: PublicSettings | null | undefined): string {
  const custom = settings?.social_google_review?.trim();
  if (custom) return custom;

  const placeId = settings?.google_place_id?.trim();
  if (placeId) {
    return `https://search.google.com/local/writereview?placeid=${encodeURIComponent(placeId)}`;
  }

  return '';
}

export function openGoogleReview(settings: PublicSettings | null | undefined) {
  const url = resolveGoogleReviewUrl(settings);
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
